import { FirstTimeFlagKey, User } from 'types/User';

export function getUserFirstTimeFlagStatus(
  firstTimeFlags: User['firstTimeFlags'],
  key: FirstTimeFlagKey,
): boolean {
  if (firstTimeFlags == null) {
    return true;
  }

  const flag = firstTimeFlags.find((f) => f.key === key);
  return flag?.created ?? false;
}
